/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimEmailWithRecipients } from './ClaimEmailWithRecipients';
import {
    ClaimEmailWithRecipientsFromJSON,
    ClaimEmailWithRecipientsFromJSONTyped,
    ClaimEmailWithRecipientsToJSON,
    ClaimEmailWithRecipientsToJSONTyped,
} from './ClaimEmailWithRecipients';

/**
 * Paginated list of emails for a claim
 * @export
 * @interface ListClaimEmailsResponse
 */
export interface ListClaimEmailsResponse {
    /**
     * 
     * @type {Array<ClaimEmailWithRecipients>}
     * @memberof ListClaimEmailsResponse
     */
    emails: Array<ClaimEmailWithRecipients>;
    /**
     * Number of emails returned in this page
     * @type {number}
     * @memberof ListClaimEmailsResponse
     */
    count: number;
    /**
     * Total number of emails for the claim across all pages
     * @type {number}
     * @memberof ListClaimEmailsResponse
     */
    total: number;
    /**
     * Maximum number of emails per page
     * @type {number}
     * @memberof ListClaimEmailsResponse
     */
    limit: number;
    /**
     * Number of emails skipped
     * @type {number}
     * @memberof ListClaimEmailsResponse
     */
    offset: number;
}

/**
 * Check if a given object implements the ListClaimEmailsResponse interface.
 */
export function instanceOfListClaimEmailsResponse(value: object): value is ListClaimEmailsResponse {
    if (!('emails' in value) || value['emails'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    return true;
}

export function ListClaimEmailsResponseFromJSON(json: any): ListClaimEmailsResponse {
    return ListClaimEmailsResponseFromJSONTyped(json, false);
}

export function ListClaimEmailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListClaimEmailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'emails': ((json['emails'] as Array<any>).map(ClaimEmailWithRecipientsFromJSON)),
        'count': json['count'],
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
    };
}

export function ListClaimEmailsResponseToJSON(json: any): ListClaimEmailsResponse {
    return ListClaimEmailsResponseToJSONTyped(json, false);
}

export function ListClaimEmailsResponseToJSONTyped(value?: ListClaimEmailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emails': ((value['emails'] as Array<any>).map(ClaimEmailWithRecipientsToJSON)),
        'count': value['count'],
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

